import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'es' | 'pt';
const translations = {
  es: {
    // Hero
    hero_location: 'Rosario · Santa Fe · Argentina',
    hero_sub1: 'Micropigmentación · Cejas · Labios',
    hero_sub2: 'Pestañas · Henna · Diseño Consciente',
    hero_desc: 'Más de 6 años transformando miradas con diseño personalizado en Rosario',
    btn_book: 'Reservar Turno →',
    btn_location: 'Ver Ubicación 📍',
    // About
    about_title: 'Quién es Iara Oliver',
    about_quote: '"Mi propósito no es solo estético: quiero que cada persona se reconozca, se guste y se sienta segura con lo que refleja en el espejo."',
    about_p1: 'Iara lleva más de 6 años acompañando a personas que buscan verse y sentirse mejor.',
    about_p2_1: 'No empezó con un local grande ni con una agenda llena de clientes. Empezó con una convicción: ',
    about_p2_2: 'Puedo cambiarle la forma de verse al espejo a alguien.',
    about_p3: 'Desde entonces no paró de formarse. Viajó. Aprendió de los mejores referentes de la industria. Volvió puliendo cada técnica, cada nuevo conocimiento y perspectiva diferente — y lo volcó todo en su trabajo en Rosario.',
    about_p4: 'Hoy, además de atender a sus clientas, forma a nuevas profesionales — porque cree que una estética consciente, responsable y con propósito puede transformar no solo rostros, sino profesiones enteras.',
    about_close: 'Cuando entrás al local de Iara, no entrás a un turno más. Entrás a una experiencia pensada para vos.',
    // Services
    services_label: 'Los Servicios',
    services_title: 'Todo lo que necesitás para potenciar tu mirada',
    services_desc: 'En un solo lugar, con técnicas de vanguardia y diseño consciente.',
    srv1_t: 'Micropigmentación de Cejas',
    srv1_d: 'Cejas perfectas al despertar, todos los días, diseñadas para tu rostro.',
    srv2_t: 'Micropigmentación de Labios',
    srv2_d: 'Definición y color natural que dura, sin lápiz ni retoques constantes.',
    srv3_t: 'Lash Lifting',
    srv3_d: 'Tus propias pestañas, curvadas y abiertas, sin extensiones ni máscara.',
    srv4_t: 'Extensión Personalizada de Pestañas',
    srv4_d: 'Volumen, largo y curvatura adaptados a tu mirada específica.',
    srv5_t: 'Henna de Cejas',
    srv5_d: 'Coloración natural que define, rellena y potencia tu arco sin compromiso.',
    srv6_t: 'Diseño y Perfilado de Cejas',
    srv6_d: 'El primer paso para entender y moldear tu marco facial.',
    // Gallery
    gallery_label: 'Portafolio',
    gallery_title: 'Miradas que Enamoran',
    // Benefits
    benefits_label: 'Resultados',
    benefits_title: 'Lo que cambia en tu vida',
    benefits_desc: 'Esto no se trata solo de "verte linda". Se trata de:',
    ben1_t: 'Recuperar tiempo',
    ben1_d: 'Menos rutina de maquillaje mañana a mañana.',
    ben2_t: 'Ganar confianza',
    ben2_d: 'Salir sin make-up y sentirte igual de segura.',
    ben3_t: 'Reconocerte',
    ben3_d: "Ver tu reflejo y pensar 'sí, esta soy yo'.",
    ben4_t: 'Libertad',
    ben4_d: 'Al mar, al gym, a la reunión. Siempre lista. Siempre vos.',
    ben5_t: 'Inversión inteligente',
    ben5_d: 'Un resultado que dura meses vs. productos que se repiten cada semana.',
    // Process
    process_label: 'Procesos',
    process_title: '¿Quieres estos resultados?',
    process_swipe: 'Deslizá para ver más',
    // Course
    course_label: 'Academia',
    course_title: 'Curso de Micropigmentación',
    course_desc: 'Si soñás con crecer en estética y aprender micropigmentación de cejas o labios, esta capacitación es para vos. Te voy a acompañar paso a paso para que te formes, te perfecciones y te animes a dar ese próximo gran paso para tu salida laboral.',
    course_cta_text: 'Inscribite aquí.',
    course_btn: 'Quiero capacitarme',
    course_msg: 'Hola! Quiero información sobre el curso de micropigmentación.',
    // Trust
    trust_title: 'Garantía de Confianza',
    trust_quote: '"Sabemos que el mayor freno no es el dinero. Es el miedo a que quede mal."',
    trust_subtitle: 'Por eso Iara trabaja de otra manera:',
    trust1: 'Consulta y diseño previo sin compromiso',
    trust2: 'Todo se conversa, se muestra y se aprueba antes de comenzar',
    trust3: 'Seguimiento post-procedimiento incluido',
    trust4: 'Más de 6 años de experiencia respaldan cada sesión',
    trust5: 'Formación internacional con los referentes más importantes de la industria',
    trust_footer: 'Tu rostro está en manos de alguien que realmente le importa el resultado.',
    trust_btn: 'Reservar Turno',
    trust_urgency1: 'Iara trabaja con turnos exclusivos. La agenda es limitada y se completa rápido.',
    trust_urgency2: 'Los turnos disponibles rotan semana a semana. Si estás leyendo esto, hay disponibilidad ahora.',
    trust_urgency3: 'No esperes a que se llene.',
    // Testimonials
    test_label: 'Testimonios',
    test_title: 'Lo que dicen nuestras clientas',
    test1_time: 'Hace 5 meses',
    test1_text: 'Increíble desde la recepción hasta los resultados. Fui a hacerme perfilado de cejas y las chicas me atendieron con mucha amabilidad, te reciben con algo para tomar, luego en la atención escuchan tus preferencias y te asesoran muy bien. Te explican todo lo que van haciendo y te van consultando todo para ver si estas conforme. Quedé más que conforme, 10/10✨.',
    test2_time: 'Hace 3 días',
    test2_text: 'Siempre es un placer ir a ese espacio tan cálido. Iara y su hermana son un amor, y súper perfeccionistas!! 100% recomendables!.',
    test3_time: 'Hace un año',
    test3_text: 'La mejor!! Atención un mil.',
    test_more: 'ver más...',
    test_less: 'ver menos',
    // Location
    loc_sub: 'Diseño consciente · Micropigmentación · Rosario',
    loc_desc: 'Un espacio diseñado para tu bienestar. Disfrutá de una experiencia estética consciente en un ambiente cálido, profesional y relajante en el corazón de Rosario.',
    loc_dir_label: 'Dirección',
    loc_dir_val: '3 de Febrero 2772, Rosario, Santa Fe',
    loc_hours_label: 'Horarios',
    loc_hours_val: 'Lun a Vie: 9:30–12:00 | 13:00–19:00',
    loc_btn: '📍 Ver en Google Maps',
    // Footer
    footer_text: '© 2026 Iara Oliver Estética. Todos los derechos reservados.',
    // Toast
    toast_de: 'de',
    toast_agendo: 'agendó un turno para',
    toast_hace: 'Hace',
    toast_min: 'min'
  },
  pt: {
    // Hero
    hero_location: 'Rosario · Santa Fe · Argentina',
    hero_sub1: 'Micropigmentação · Sobrancelhas · Lábios',
    hero_sub2: 'Cílios · Henna · Design Consciente',
    hero_desc: 'Mais de 6 anos transformando olhares com design personalizado em Rosario',
    btn_book: 'Agendar Horário →',
    btn_location: 'Ver Localização 📍',
    // About
    about_title: 'Quem é Iara Oliver',
    about_quote: '"Meu propósito não é apenas estético: quero que cada pessoa se reconheça, goste de si mesma e se sinta segura com o que reflete no espelho."',
    about_p1: 'Iara acompanha há mais de 6 anos pessoas que buscam se ver e se sentir melhor.',
    about_p2_1: 'Não começou com um espaço grande nem com uma agenda cheia de clientes. Começou com uma convicção: ',
    about_p2_2: 'Posso mudar a forma como alguém se vê no espelho.',
    about_p3: 'Desde então, não parou de se formar. Viajou. Aprendeu com os melhores referentes da indústria. Voltou aprimorando cada técnica, cada novo conhecimento e perspectiva diferente — e aplicou tudo em seu trabalho em Rosario.',
    about_p4: 'Hoje, além de atender suas clientes, forma novas profissionais — porque acredita que uma estética consciente, responsável e com propósito pode transformar não apenas rostos, mas profissões inteiras.',
    about_close: 'Quando você entra no espaço da Iara, não entra para mais um horário. Entra para uma experiência pensada para você.',
    // Services
    services_label: 'Os Serviços',
    services_title: 'Tudo o que você precisa para realçar seu olhar',
    services_desc: 'Em um só lugar, com técnicas de vanguarda e design consciente.',
    srv1_t: 'Micropigmentação de Sobrancelhas',
    srv1_d: 'Sobrancelhas perfeitas ao acordar, todos os dias, desenhadas para o seu rosto.',
    srv2_t: 'Micropigmentação de Lábios',
    srv2_d: 'Definição e cor natural que dura, sem lápis ou retoques constantes.',
    srv3_t: 'Lash Lifting',
    srv3_d: 'Seus próprios cílios, curvados e abertos, sem extensões ou rímel.',
    srv4_t: 'Extensão Personalizada de Cílios',
    srv4_d: 'Volume, comprimento e curvatura adaptados ao seu olhar específico.',
    srv5_t: 'Henna de Sobrancelhas',
    srv5_d: 'Coloração natural que define, preenche e realça seu arco sem compromisso.',
    srv6_t: 'Design e Perfilado de Sobrancelhas',
    srv6_d: 'O primeiro passo para entender e moldar sua moldura facial.',
    // Gallery
    gallery_label: 'Portfólio',
    gallery_title: 'Olhares que Apaixonam',
    // Benefits
    benefits_label: 'Resultados',
    benefits_title: 'O que muda na sua vida',
    benefits_desc: 'Isso não se trata apenas de "ficar bonita". Trata-se de:',
    ben1_t: 'Recuperar tempo',
    ben1_d: 'Menos rotina de maquiagem todas as manhãs.',
    ben2_t: 'Ganhar confiança',
    ben2_d: 'Sair sem maquiagem e se sentir igualmente segura.',
    ben3_t: 'Reconhecer-se',
    ben3_d: "Ver seu reflexo e pensar 'sim, essa sou eu'.",
    ben4_t: 'Liberdade',
    ben4_d: 'No mar, na academia, na reunião. Sempre pronta. Sempre você.',
    ben5_t: 'Investimento inteligente',
    ben5_d: 'Um resultado que dura meses vs. produtos que se repetem toda semana.',
    // Process
    process_label: 'Processos',
    process_title: 'Quer esses resultados?',
    process_swipe: 'Deslize para ver mais',
    // Course
    course_label: 'Academia',
    course_title: 'Curso de Micropigmentação',
    course_desc: 'Se você sonha em crescer na estética e aprender micropigmentação de sobrancelhas ou lábios, esta capacitação é para você. Vou te acompanhar passo a passo para que você se forme, se aperfeiçoe e tenha coragem de dar esse próximo grande passo para sua carreira profissional.',
    course_cta_text: 'Inscreva-se aqui.',
    course_btn: 'Quero me capacitar',
    course_msg: 'Olá! Quero informações sobre o curso de micropigmentação.',
    // Trust
    trust_title: 'Garantia de Confiança',
    trust_quote: '"Sabemos que o maior obstáculo não é o dinheiro. É o medo de que fique ruim."',
    trust_subtitle: 'Por isso a Iara trabalha de outra maneira:',
    trust1: 'Consulta e design prévio sem compromisso',
    trust2: 'Tudo é conversado, mostrado e aprovado antes de começar',
    trust3: 'Acompanhamento pós-procedimento incluído',
    trust4: 'Mais de 6 anos de experiência respaldam cada sessão',
    trust5: 'Formação internacional com os referentes mais importantes da indústria',
    trust_footer: 'Seu rosto está nas mãos de alguém que realmente se importa com o resultado.',
    trust_btn: 'Agendar Horário',
    trust_urgency1: 'A Iara trabalha com horários exclusivos. A agenda é limitada e preenche rápido.',
    trust_urgency2: 'Os horários disponíveis rodam semana a semana. Se você está lendo isso, há disponibilidade agora.',
    trust_urgency3: 'Não espere encher.',
    // Testimonials
    test_label: 'Depoimentos',
    test_title: 'O que dizem nossas clientes',
    test1_time: 'Há 5 meses',
    test1_text: 'Incrível desde a recepção até os resultados. Fui fazer o perfilado de sobrancelhas e as meninas me atenderam com muita gentileza, te recebem com algo para beber, depois no atendimento escutam suas preferências e te assessoram muito bem. Te explicam tudo o que vão fazendo e vão te consultando tudo para ver se você está satisfeita. Fiquei mais do que satisfeita, 10/10✨.',
    test2_time: 'Há 3 dias',
    test2_text: 'Sempre é um prazer ir a esse espaço tão acolhedor. A Iara e sua irmã são um amor, e super perfeccionistas!! 100% recomendáveis!.',
    test3_time: 'Há um ano',
    test3_text: 'A melhor!! Atendimento nota mil.',
    test_more: 'ver mais...',
    test_less: 'ver menos',
    // Location
    loc_sub: 'Design consciente · Micropigmentação · Rosario',
    loc_desc: 'Um espaço projetado para o seu bem-estar. Desfrute de uma experiência estética consciente em um ambiente acolhedor, profissional e relaxante no coração de Rosario.',
    loc_dir_label: 'Endereço',
    loc_dir_val: '3 de Febrero 2772, Rosario, Santa Fe',
    loc_hours_label: 'Horários',
    loc_hours_val: 'Seg a Sex: 9:30–12:00 | 13:00–19:00',
    loc_btn: '📍 Ver no Google Maps',
    // Footer
    footer_text: '© 2026 Iara Oliver Estética. Todos os direitos reservados.',
    // Toast
    toast_de: 'de',
    toast_agendo: 'agendou um horário para',
    toast_hace: 'Há',
    toast_min: 'min'
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: keyof (typeof translations)['es']) => string;
  isReady: boolean;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>('es');
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    const savedLang = localStorage.getItem('iaraLang') as Language;
    if (savedLang && (savedLang === 'es' || savedLang === 'pt')) {
      setLanguageState(savedLang);
      document.documentElement.lang = savedLang;
    }
    setIsReady(true);
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('iaraLang', lang);
    document.documentElement.lang = lang;
  };
  const t = (key: keyof (typeof translations)['es']) => {
    return translations[language][key] || translations['es'][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    isReady
  }} data-id="element-148">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}